import React from "react";
import Typography from "@mui/material/Typography";
import { Avatar, Badge, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UserCard = ({ user }) => {
  const navigate = useNavigate();
  return (
    user &&
    user.nickname && (
      <Box
        sx={{
          display:"flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          alignmentBaseline: "baseline",
          cursor: "pointer",
        }}
        onClick={() => navigate("/profile", { state: { userId: user.id } })}
      >
        <Tooltip title={`${user.nickname} - ${user.fullName}`} arrow>
          <Badge
            color="success"
            badgeContent="online"
            variant="dot"
            overlap="circular"
            invisible={!user.isOnline}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Avatar
              sx={{ width: 48, height: 48 }}
              alt={user.nickname}
              src={`/static/images/${user.avatarFileName ?? "default.jpg"}`}
            />
          </Badge>
        </Tooltip>
        <Typography sx={{ fontSize: 12 }}>{user.nickname}</Typography>
      </Box>
    )
  );
};

export default UserCard;
